// extracted by mini-css-extract-plugin
export var colourBase = "kljBAPOkZB9yQeieU9vL";
export var colourDisabled = "i8CS2dnSHqwQuVGxrZRq";
export var colourInverted = "rQbD04wjgD8lCfHhKkK1";
export var colourNegative = "sRKqoLKM6axX7VDFXRul";
export var colourPositive = "pdrdUhoSp064H1rM7jY7";
export var colourSubdued = "IUcDrT9RBSmI1jtZDNJW";
export var colourSubtle = "Mph8TfaehRAsX2F2ffDH";
export var colourUrgencyHigh = "BFl8a5GF3Bs6BqB2K2T0";
export var colourUrgencyMedium = "Ic_PIIx5JaldQ467IuLQ";
export var colourWarning = "aYvy269BsVfu3PoGlV_R";
export var colourWhite = "JEt5cPmVwusllJ1xhT7F";